import FullscreenSpinner from 'components/FullscreenSpinner'
import useFetch from 'hooks/useFetch'
import { API_URL } from 'myconstant'
import AdminLayout from 'pages/components/admin/AdminLayout'
import React, { useCallback, useRef, useState } from 'react'
import '@toast-ui/editor/dist/toastui-editor.css'
import { Editor } from '@toast-ui/react-editor'
import { Breadcrumb, Button, Input, notification, Select, Table, Upload } from 'antd'
import { useEffect } from 'react'
import axios from 'axios'
import { addQueryParameter } from 'utils'
import date from 'date-and-time'
import styles from './BoardWrite.module.scss'

import fontSize from 'tui-editor-plugin-font-size'
import 'tui-editor-plugin-font-size/dist/tui-editor-plugin-font-size.css'

import colorSyntax from '@toast-ui/editor-plugin-color-syntax'
import 'tui-color-picker/dist/tui-color-picker.css'
import '@toast-ui/editor-plugin-color-syntax/dist/toastui-editor-plugin-color-syntax.css'

import { useLocation, useNavigate } from 'react-router-dom'
import { InboxOutlined, UploadOutlined } from '@ant-design/icons'

const MAX_ATTACHMENTS = 10
const MAX_ATTACHMENT_SIZE_MB = 20

const BoardWrite = () => {
  const { state } = useLocation()
  const {
    id = null,
    title: pTitle = null,
    content: pContent = null,
    image = null,
    category: pCategory,
    sub_category: pSubCategory,
  } = state ? state : {}

  const baseUrl = '/api/board'
  const [title, setTitle] = useState(pTitle || '')
  const [fileList, setFileList] = useState([])
  const editorRef = useRef()
  const navigate = useNavigate()
  const [category, setCategory] = useState(pCategory)
  const [subCategory, setSubCategory] = useState(pSubCategory)
  const callbackUrl =
    pCategory === '공지사항' ? `/admin/board` : `/admin/portfolio`
  const [originalImgPath, setOriginalImgPath] = useState(image)
  const isNotice = category !== '주요 프로젝트'
  const [attachments, setAttachments] = useState([])
  const [deletedAttachmentIds, setDeletedAttachmentIds] = useState([])
  useEffect(() => {
    if (id && pContent) {
      editorRef.current?.getInstance().setHTML(pContent)
    }
  }, [])

  useEffect(() => {
    if (!id || !isNotice) return
    axios
      .get(`${baseUrl}/${id}`)
      .then(({ data }) => {
        setAttachments(
          (data?.attachments || []).map((a) => ({
            uid: `saved-${a.id}`,
            savedId: a.id,
            name: a.original_file_name,
            status: 'done',
            url: `/api/file/attachment/${a.id}`,
          }))
        )
      })
      .catch((e) => console.log(e))
  }, [id, isNotice])

  const getFormData = (content) => {
    const formData = new FormData()

    if (category === '주요 프로젝트') {
      formData.append(
        'file',
        fileList && fileList[0] ? fileList[0].originFileObj : null
      )
      formData.append('originalImgPath', originalImgPath)
    }
    if (isNotice) {
      attachments
        .filter((a) => !a.savedId)
        .forEach((a) => formData.append('attachments', a.originFileObj))
      formData.append(
        'deletedAttachmentIds',
        JSON.stringify(deletedAttachmentIds)
      )
    }
    formData.append('category', category)
    formData.append('subcategory', subCategory || '공지사항')
    formData.append('title', title)
    formData.append('content', content)
    return formData
  }

  const save = () => {
    const content = editorRef.current?.getInstance().getHTML()
    if (!title || !content || content === '<p><br></p>') {
      notification.error({
        message: '제목과 내용이 모두 입력되어야 합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return
    }
    if (category === '주요 프로젝트' && !subCategory) {
      notification.error({
        message: 'Category가 선택되어야 합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return
    }
    const formData = getFormData(content)
    debugger
    axios
      .post(baseUrl, formData, {
        header: { 'content-type': 'multipart/form-data' },
      })
      .then((res) => {
        notification.info({
          message: '저장되었습니다.',
          placement: 'bottom',
          duration: 2,
        })
        navigate(callbackUrl)
      })
      .catch((e) => {
        notification.error({
          message: e.response?.data || e.message,
          placement: 'bottom',
          duration: 2,
        })
      })
  }

  const onChange = ({ fileList: newFileList }) => {
    setFileList([newFileList.pop()])
  }

  const beforeAttachmentUpload = (file) => {
    if (attachments.length >= MAX_ATTACHMENTS) {
      notification.error({
        message: `첨부파일은 최대 ${MAX_ATTACHMENTS}개까지 올릴 수 있습니다.`,
        placement: 'bottom',
        duration: 2,
      })
      return Upload.LIST_IGNORE
    }
    if (file.size > MAX_ATTACHMENT_SIZE_MB * 1024 * 1024) {
      notification.error({
        message: `${file.name}: ${MAX_ATTACHMENT_SIZE_MB}MB 이하 파일만 올릴 수 있습니다.`,
        placement: 'bottom',
        duration: 2,
      })
      return Upload.LIST_IGNORE
    }
    // 저장 버튼을 누를 때 게시글과 함께 전송한다.
    return false
  }

  const onAttachmentRemove = (file) => {
    if (file.savedId) {
      setDeletedAttachmentIds((ids) => [...ids, file.savedId])
    }
  }

  const modifyContent = () => {
    const content = editorRef.current?.getInstance().getHTML()
    if (!title || !content || content === '<p><br></p>') {
      notification.error({
        message: '제목과 내용이 모두 입력되어야 합니다.',
        placement: 'bottom',
        duration: 2,
      })
      return
    }
    const formData = getFormData(content)

    if (confirm('수정 전 내용은 복원되지 않습니다. 수정하시겠습니까?')) {
      axios
        .patch(`${baseUrl}/${id}`, formData, {
          header: { 'content-type': 'multipart/form-data' },
        })
        .then((res) => {
          notification.info({
            message: '수정되었습니다.',
            placement: 'bottom',
            duration: 2,
          })
          navigate(callbackUrl)
        })
        .catch((e) => {
          notification.error({
            message: e.response?.data || e.message,
            placement: 'bottom',
            duration: 2,
          })
        })
    }
  }

  const deleteContent = () => {
    if (confirm('삭제하시겠습니까? 삭제된 내용은 복원되지 않습니다')) {
      axios.delete(`${baseUrl}/${id}`).then((res) => {
        notification.info({
          message: '삭제되었습니다.',
          placement: 'bottom',
          duration: 2,
        })
        navigate(callbackUrl)
      })
    }
  }

  return (
    <AdminLayout>
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>{category === '주요 프로젝트' ? 'Portfolio' : 'Story'}</Breadcrumb.Item>
        <Breadcrumb.Item>{category === '주요 프로젝트' ? 'Portfolio' : '공지사항'}</Breadcrumb.Item>
        <Breadcrumb.Item>{id && pContent ? '수정' : '작성'}</Breadcrumb.Item>
      </Breadcrumb>
      <section className={styles['button-area']}>
        <Input
          addonBefore="제목"
          onChange={(e) => setTitle(e.target.value)}
          value={title}
          style={{ marginBottom: '10px' }}
        />
      </section>
      {category === '주요 프로젝트' ? (
        <>
          <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <Select
              placeholder="Category"
              style={{ width: '200px' }}
              defaultValue={subCategory}
              // onClick={(e) => {
              //   e.preventDefault()
              //   e.stopPropagation()
              // }}
              onChange={(key) => setSubCategory(key)}
            >
              <Select.Option key="전략적 관광컨설팅">
                전략적 관광컨설팅
              </Select.Option>
              <Select.Option key="관광진흥컨설팅">관광진흥컨설팅</Select.Option>
              <Select.Option key="운영관리 및 사업화">
                운영관리 및 사업화
              </Select.Option>
              <Select.Option key="공간 및 관광개발사업">
                공간 및 관광개발사업
              </Select.Option>
            </Select>
          </div>
          <div style={{ marginTop: '20px', marginBottom: '20px' }}>
            <div>
              {originalImgPath ? (
                <>
                  {originalImgPath}
                  <Button
                    style={{ marginLeft: '10px' }}
                    onClick={() => setOriginalImgPath('deleted')}
                  >
                    이미지삭제
                  </Button>
                </>
              ) : null}
            </div>
            <Upload onChange={onChange} fileList={fileList}>
              <Button icon={<UploadOutlined />}>Click to Upload</Button>
            </Upload>
          </div>
        </>
      ) : null}
      <Editor
        ref={editorRef}
        previewStyle="vertical"
        height="600px"
        initialEditType="wysiwyg"
        useCommandShortcut={true}
        plugins={[fontSize, colorSyntax]}
        toolbarItems={[
          // ['heading'],
          [],
          ['bold', 'strike', 'link'],
          // ['hr', 'table', 'link'],
          // ['ul', 'task', 'indent', 'outdent'],
        ]}
      />
      {isNotice ? (
        <section className={styles['attachment-area']}>
          <div className={styles['attachment-label']}>
            첨부파일
            <span className={styles['attachment-count']}>
              {attachments.length} / {MAX_ATTACHMENTS}
            </span>
          </div>
          <Upload.Dragger
            multiple
            fileList={attachments}
            beforeUpload={beforeAttachmentUpload}
            onChange={({ fileList: newFileList }) =>
              setAttachments(newFileList.slice(0, MAX_ATTACHMENTS))
            }
            onRemove={onAttachmentRemove}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">
              클릭하거나 파일을 이 영역으로 끌어다 놓으세요
            </p>
            <p className="ant-upload-hint">
              최대 {MAX_ATTACHMENTS}개, 파일당 {MAX_ATTACHMENT_SIZE_MB}MB까지
              올릴 수 있습니다. 저장할 때 함께 등록됩니다.
            </p>
          </Upload.Dragger>
        </section>
      ) : null}
      <section className={styles['button-area']}>
        {id ? (
          <>
            <Button type="primary" onClick={modifyContent}>
              수정
            </Button>
            <Button
              type="primary"
              onClick={deleteContent}
              style={{ marginLeft: '5px' }}
            >
              삭제
            </Button>
          </>
        ) : (
          <Button type="primary" onClick={save}>
            글쓰기
          </Button>
        )}
      </section>
    </AdminLayout>
  )
}

export default BoardWrite
